/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=7df13794&scoped=true"
import script from "./ChatBubble.vue?vue&type=script&lang=js"
export * from "./ChatBubble.vue?vue&type=script&lang=js"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=7df13794&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df13794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df13794')) {
      api.createRecord('7df13794', component.options)
    } else {
      api.reload('7df13794', component.options)
    }
    module.hot.accept("./ChatBubble.vue?vue&type=template&id=7df13794&scoped=true", function () {
      api.rerender('7df13794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/corefront/chat/ChatBubble.vue"
export default component.exports